export function createSafeJSON(widgetName) {
    return (json, messageError) => {
        try {
            return JSON.parse(json || '{}');
        } catch (error) {
            console.error(`duda-widgts:${widgetName}`, messageError, json);
            return {};
        }
    }
}
